// src/components/CategoryWheel.jsx
import React, { useState } from "react";
import "./CategoryWheel.css";

function CategoryWheel({ categoriasPendientes, onSelect, disabled }) {
  const [resaltada, setResaltada] = useState(null);
  const [girando, setGirando] = useState(false);

  const iniciarRuleta = () => {
    if (girando || categoriasPendientes.length === 0) return;

    setGirando(true);
    let pos = 0;
    const total = categoriasPendientes.length;
    const vueltas = 2 * total + Math.floor(Math.random() * total) + 5;
    let paso = 0;
    let velocidad = 85;

    function animar() {
      setResaltada(pos % total);
      pos++;
      paso++;
      if (paso < vueltas) {
        // Desaceleración progresiva al final
        if (paso > vueltas - total) velocidad += 30;
        setTimeout(animar, velocidad);
      } else {
        setTimeout(() => {
          setGirando(false);
          setResaltada(null);
          onSelect(categoriasPendientes[(pos - 1) % total]);
        }, 480);
      }
    }
    animar();
  };

  return (
    <div className="wheelboard-container">
      <h3>Elige tu tema con la ruleta:</h3>
      <div className="casillas-ruleta">
        {categoriasPendientes.map((cat, idx) => (
          <div
            key={cat}
            className={`casilla-ruleta ${resaltada === idx ? "resaltada" : ""}`}
          >
            {cat}
          </div>
        ))}
      </div>
      <button
        className="btn-girar"
        onClick={iniciarRuleta}
        disabled={girando || categoriasPendientes.length === 0 || disabled}
      >
        <span role="img" aria-label="ruleta">🎲</span> Girar
      </button>
    </div>
  );
}

export default CategoryWheel;
